import MaskComponent from './Mask.vue';
export const Mask = MaskComponent;
export default Mask;
